var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 50,
    viewBox: "0 0 20 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V50L10.5 44.1667L0 50V0Z",
    fill: "#1CD490"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbon);
export default __webpack_public_path__ + "static/media/Ribbon.882e75f6e4ee802201c2a3c0ca8fe234.svg";
export { ForwardRef as ReactComponent };